import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { useRef } from 'react';

import pinEditMap from 'assets/images/pseudo_pin_map.png';

import { PseudoMarkerProps } from './PseudoMarker.type';

export const PseudoMarker = ({
    index,
    onPseudoMarkerClick,
    position,
}: PseudoMarkerProps) => {
    const markerRef = useRef<L.Marker>(null);

    const eventHandlers = {
        click: () => {
            onPseudoMarkerClick(position, index);
        },
    };

    const iconEdit = L.icon({
        iconUrl: pinEditMap,
        iconSize: [30, 30],
        iconAnchor: [15, 15],
        shadowUrl: undefined,
    });

    return (
        <Marker
            ref={markerRef}
            position={position}
            draggable={false}
            eventHandlers={eventHandlers}
            icon={iconEdit}
        />
    );
};
